import React from 'react'
import styles from '../Accommodation/Accommodation.module.css'

const Accommodation = () => {
    return (
        <div className={styles.containerBox}>
            <div className={styles.container}>
                <div className={styles.AccommodationImage}>
                    <img src='Images/without-accommodation2.webp' alt=' woman smiling about clarity and continuous focus without accommodation' loading="lazy" decoding="async" />
                    <div className={styles.circleDiv}><p>Continuous focus, <br /><b> from near to far.</b>
                    </p>

                    </div>
                </div>


            </div>
            <div className={styles.rightContentImg}>
                <div className={styles.rightContent}><p>Deseyne® Extended Depth of Focus (EDOF) technology delivers smooth, continuous focus across near, intermediate, and distance vision, providing clear, natural vision without compromise. This performance is enabled by Bruno Vision Care’s patented hyper-refractive central zone, engineered to precisely redirect light in a controlled manner. 
                    <br/>
                    The result is a clear clinical advantage over multifocal lenses, the only other available contact lens option for presbyopia, which rely on multiple optical zones and often require prolonged visual and cognitive adaptation.
                </p>
                </div>
            </div>

        </div>
    )
}

export default Accommodation
